import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { TabStrip } from './TabStrip';

/**
 * Settings layout: same top bar + tab strip chrome as the workspace, with a
 * full-bleed area below for Settings' own section rail + content. No workspace
 * SideNav — Settings is its own focused, dedicated destination.
 */
export function SettingsLayout() {
  return (
    <div className="flex h-screen w-full flex-col gap-2 overflow-hidden bg-[var(--topbar)] p-2">
      <TopBar />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-border bg-background shadow-sm">
        <TabStrip />
        <div className="min-h-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
